import type { AccessType } from '@/features/instructions/types'
import type { Visibility } from '../types'

const TO = new Map<AccessType, Visibility>([
  ['private', 'unpublished'],
  ['link', 'link'],
  ['public', 'catalog'],
])
const FROM = new Map<Visibility, AccessType>([
  ['unpublished', 'private'],
  ['link', 'link'],
  ['catalog', 'public'],
])

/** Единственный перевод между UI-шкалой доступа (общей со статьями) и шкалой контракта. */
export const toVisibility = (a: AccessType): Visibility => TO.get(a) ?? 'unpublished'
export const fromVisibility = (v: Visibility): AccessType => FROM.get(v) ?? 'private'
